actual object EndGameAds {
    actual fun preload() = Unit
    actual fun show(onDismissed: () -> Unit) = onDismissed()
}
